module.exports = __webpack_public_path__ + "static/media/Albatross_Logo_6_Version_4.fd1e8a76.png";